if (!customElements.get('liontek-community')) {
  customElements.define('liontek-community', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.posts = [];
      this.querySelectorAll('[data-inline-video]').forEach(host => {
        let url;
        try { url = new URL(host.dataset.post); } catch { return; }
        const match = url.pathname.match(/^\/(?:p|reel)\/([A-Za-z0-9_-]+)\/?$/);
        if (url.protocol !== 'https:' || !['instagram.com', 'www.instagram.com'].includes(url.hostname) || !match) return;
        this.posts.push({ host, cover: host.firstElementChild, code: match[1], visible: false });
      });
      this.update = post => {
        const shouldLoad = post.visible && document.visibilityState !== 'hidden';
        if (shouldLoad && !post.player) {
          const frame = document.createElement('iframe');
          frame.title = post.host.dataset.title;
          frame.allow = 'encrypted-media; fullscreen';
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.src = `https://www.instagram.com/p/${post.code}/embed/`;
          const player = document.createElement('div');
          player.className = 'liontek-community__player';
          player.append(frame);
          const poster = document.createElement('div');
          poster.className = 'liontek-community__poster liontek-community__cover';
          poster.setAttribute('aria-hidden', 'true');
          const image = post.cover.querySelector('img');
          if (image) poster.append(image.cloneNode(true));
          const mark = document.createElement('span');
          mark.className = 'liontek-community__play liontek-community__play--corner';
          mark.textContent = '▶';
          poster.append(mark);
          post.player = player;
          post.frame = frame;
          post.host.classList.add('liontek-community__media--playing');
          post.host.replaceChildren(player, poster);
          this.size(post.host);
        } else if (!shouldLoad && post.player) {
          clearTimeout(post.revealTimer);
          post.revealTimer = null;
          post.host.replaceChildren(post.cover);
          post.host.classList.remove('liontek-community__media--playing');
          post.player = null;
          post.frame = null;
          post.host.removeAttribute('data-started');
        }
        if (this.posts.some(item => item.player)) {
          if (!this.focusTimer) this.focusTimer = setInterval(this.onPlayerFocus, 150);
        } else {
          clearInterval(this.focusTimer);
          this.focusTimer = null;
        }
      };
      this.size = host => {
        const scale = host.getBoundingClientRect().width / 400;
        host.style.setProperty('--player-scale', scale);
      };
      this.resize = new ResizeObserver(entries => entries.forEach(entry => this.size(entry.target)));
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
        const post = this.posts.find(item => item.host === entry.target);
        post.visible = entry.isIntersecting;
        this.update(post);
      }), { rootMargin: '300px 0px', threshold: 0.01 });
      this.posts.forEach(post => {
        this.observer.observe(post.host);
        this.resize.observe(post.host);
      });
      this.onPlayerFocus = () => {
        const post = this.posts.find(item => item.frame === document.activeElement);
        if (!post || post.host.hasAttribute('data-started') || post.revealTimer) return;
        post.revealTimer = setTimeout(() => {
          post.revealTimer = null;
          if (!post.frame || document.activeElement !== post.frame) return;
          this.posts.forEach(other => {
            if (other !== post && other.frame && other.host.hasAttribute('data-started')) {
              other.frame.src = other.frame.src;
              other.host.removeAttribute('data-started');
            }
          });
          post.host.setAttribute('data-started', 'true');
        }, 300);
      };
      window.addEventListener('blur', this.onPlayerFocus);
      this.onVisibility = () => this.posts.forEach(this.update);
      document.addEventListener('visibilitychange', this.onVisibility);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.resize?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('blur', this.onPlayerFocus);
      clearInterval(this.focusTimer);
      this.focusTimer = null;
      this.posts?.forEach(post => {
        clearTimeout(post.revealTimer);
        post.host.replaceChildren(post.cover);
        post.host.classList.remove('liontek-community__media--playing');
      });
      this.observer = null;
    }
  });
}
